import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { provPopupTemplate } from '../data/htmlTemplates.js';

import Mustache from 'mustache';

import { Sesion, Datos, Layers } from '../main.js';
import { Mimapa } from './map.js';
import { sumPropInfoTaxon, getTaxonLabel, correspondenciaTaxonMulti } from './taxons.js';
import { getLiteral, getDate, uriToLiteral, firstUppercase, getColor, getColorMix, getPreferredLang } from './util.js';


let featprovs; // aquí guardo las features de las provincias (ver cargarProvincias)
let provspintadas = false;

function inicializarProvincias() {
	// devuelvo la capa GEOJSON para las provincias
	return L.geoJson(null, {
		style: estiloProvincia,
		onEachFeature: enCadaProvincia
	}).addTo(Mimapa);
}

function cargarProvincias() {
	// preparo los datos en GeoJSON de las provincias
	featprovs = [];
	const pruris = Object.keys(Datos.provs);
	for (let pruri of pruris) {
		let prov = Datos.provs[pruri];
		let prdata = {
			"type": "Feature",
			"properties" : {}
		};
		// sólo incluyo la provincia si hay geometría
		if (prov.geometry) {
			prdata.geometry = prov.geometry;
			prdata.properties = prov;
			// borro redundancia geometrías en properties
			delete prdata.properties.geometry;				
			featprovs.push(prdata);				
		}		
	}
}

function pintarProvincias() {
	if (!provspintadas && featprovs) {
		// cargo provincias en la capa
		Layers.provs.addData(featprovs);
		Layers.provs.bringToBack();
		// pongo flag a true
		provspintadas = true;
	}
}

function ajustarColorProvincias() {
	if (provspintadas) {
		for (let prov of featprovs) {
			const layer = Object.values(Layers.provs._layers).find((layer) => layer.feature.properties.iri === prov.properties.iri);
			// reajusto estilo
			layer.setStyle( estiloProvincia(prov) );
		}
	}
}

function ajustarPopupsProvincias() {
	if (provspintadas) {
		for (let prov of featprovs) {
			const layer = Object.values(Layers.provs._layers).find((layer) => layer.feature.properties.iri === prov.properties.iri);
			// reajusto popup
			layer.bindPopup(popupProvincia(prov), {maxWidth: 800});
		}
	}
}

// ESTILOS PROVINCIAS
// preparo estilo polígonos
function estiloProvincia(prov) {
	const sat = Sesion.estado.mapType === config.mapConfig.mapType[1]; // capa satélite
	return {
		fillColor: sat? config.colores[config.coltesimpind][6] : colorProvincia(prov.properties, false), // color de relleno  
		weight: sat? 1.5 : 1,
		opacity: 1,
		color: sat? config.colores[config.coltesimpind][1] : colorProvincia(prov.properties, true),
		dashArray: '1',
		fillOpacity: sat? 0.1 : 0.3
	};
}
function realceProvincia(e) {
	if (Sesion.zoom >= config.zParcela)
		return; // no hay realce cuando el zoom es muy grande
    const layer = e.target;
	const sat = Sesion.estado.mapType === config.mapConfig.mapType[1]; // capa satélite
	layer.setStyle({
		weight: sat? 3 : 2,
		dashArray: '',
		fillOpacity: sat? 0.2 : 0.4
	});
}
function quitarRealceProvincia(e) {
    let layer = e.target;
    if (e.type === "popupclose" || !(layer.getPopup() && layer.getPopup().isOpen()))
	    Layers.provs.resetStyle(layer);
}/*
function zoomProvincia(e) {
	Map.fitBounds(e.target.getBounds());
	L.DomEvent.stopPropagation(e); // para que el mapa no haga doubleClickZoom 
}*/
function enCadaProvincia(feature, layer) {
	// pongo popup
	layer.bindPopup(popupProvincia(feature), {maxWidth: 800})
		// eventos de realce
		.on({
			popupopen: realceProvincia,
			popupclose: quitarRealceProvincia,
    	    mouseover: realceProvincia,
	        mouseout: quitarRealceProvincia
		});
}
function popupProvincia(feature) {
	let prprops = feature.properties;
	const ifn = Sesion.estado.ifn? Sesion.estado.ifn : config.ifnVersions[config.ifnVersions.length -1];
		
	// preparo plantilla para el mustache
	let prtemp = {};
	//prtemp.prov = feature.properties.province; // etiqueta con el nombre
	prtemp.prov = getLiteral(feature.properties.label); // etiqueta con el nombre
	// fuente
	prtemp.source = feature.properties.isPortuguese? getLiteral(dict.sourceifnPT) 
		: getLiteral(dict["source"+ifn]);
	// incluyo tipo
	prtemp.type = feature.properties.isPortuguese? getLiteral(dict.portugueseRegion) : getLiteral(dict.spanishProvince) ;
	// dataCapture
	if (prprops[ifn] && prprops[ifn].begins && prprops[ifn].ends) {
		prtemp.dataCapture = getLiteral(dict.dataCapturefrom) + getDate(prprops[ifn].begins)
				+ getLiteral(dict.dataCaptureto) + getDate(prprops[ifn].ends);
	}
	// encabezado (especies)
	prtemp.head = [];
	prtemp.head.push('<th scope="col"></th>'); // primera celda del encabezado vacío
	// taxones seleccionados (si los hay)
	for (let tx of Sesion.taxones)
		prtemp.head.push( '<th scope="col" colspan="2" class="text-end">' + getTaxonLabel(tx, Sesion.nomci, true) + '</th>' );
	// si no hay taxones seleccionados no pongo tabla
	if (Sesion.taxones.length == 0)
		prtemp.notabla = true;
	// todos los taxones
	prtemp.head.push( '<th scope="col" class="text-end">' + getLiteral(dict.all) + '</th>' );
	// datos
	prtemp.rows = [];	
	
	// datos de existencias
	const infoSpecies = prprops[ifn]? prprops[ifn].infoSpecies : prprops.infoSpecies;
	if (infoSpecies) {	
		// convierto en array si hace falta para el análisis
		const infosar = Array.isArray(infoSpecies)? infoSpecies : [infoSpecies];	
		// preparo objetos para iterar
		let objs = [];
		objs.push( { "prop" : "numberTrees", "head" : getLiteral(dict.numbertrees) } );
		objs.push( { "prop" : "basalArea", "head" : getLiteral(dict.basalareaM2) } );
		objs.push( { "prop" : "volumeWithBark", "head" : getLiteral(dict.volumewithbarkM3) } );
		if (!feature.properties.isPortuguese) {
			objs.push( { "prop" : "volumeWithoutBark", "head" : getLiteral(dict.volumewithoutbarkM3) } );
			objs.push( { "prop" : "volumeFirewood", "head" : getLiteral(dict.volumefirewoodM3) } );
		}
		if (!feature.properties.isPortuguese)// && ifn ==="ifn3")
			objs.push( { "prop" : "forestSurface", "head" : getLiteral(dict.forestSurfaceHa) } );
		// itero
		for (let obj of objs) {
			let row = {};
			row.head = obj.head;
			row.els = [];
			// suma total (con redondeo)
			let sumtotal = Math.round(sumPropInfoTaxon(infosar, obj.prop, config.treeUri));
			// taxones seleccionados (si los hay)
			for (let tx of Sesion.taxones) {
				// obtengo suma de la especies
				let sumesp = Math.round(sumPropInfoTaxon(infosar, obj.prop, tx));
				// CASO PORTUGUÉS: mapeo del IFN3 a otros inventarios
				if (feature.properties.isPortuguese && ifn !== "ifn3") {
					// obtengo array con los mapeos
					const txpt = correspondenciaTaxonMulti( [tx], "ifn3");
					// calculo suma
					sumesp = 0;
					for (const txptel of txpt)
						sumesp += Math.round(sumPropInfoTaxon(infosar, obj.prop, txptel));				
				}
				if (sumesp != 0) {
					const val = Number(sumesp).toLocaleString(getPreferredLang());
					let valperc = '';
					// pongo porcentaje
					if (sumtotal > 0) {
						const perc = 100 * sumesp / sumtotal;
						valperc = ' (' + Number(perc.toFixed(1)).toLocaleString(getPreferredLang()) + '%)';				
					}
					row.els.push(val);
					row.els.push(valperc);
				}
				else {
					row.els.push( '' );
					row.els.push( '' );
				}
			}
			// todos los taxones
			row.els.push( Number(sumtotal).toLocaleString(getPreferredLang()) );
			// incluyo fila
			prtemp.rows.push(row);	
		}
	}
	// datos parcelas
	if (prprops[ifn] && prprops[ifn].nallplots) {	
		let row = {};
		row.head = getLiteral(dict.plotsinv);
		row.els = [];
		// taxones seleccionados (si los hay)
		for (let tx of Sesion.taxones) {
			if (prprops[ifn].nplots && prprops[ifn].nplots[tx] 
					&& prprops[ifn].nplots[tx] > 0) { // si hay parcelas...
				const val = Number(prprops[ifn].nplots[tx]).toLocaleString(getPreferredLang());
				let valperc = '';
				// pongo porcentaje de parcelas de la especie
				if (prprops[ifn].nallplots > 0) {
					const perc = 100 * prprops[ifn].nplots[tx] / prprops[ifn].nallplots;
					valperc = '(' + Number(perc.toFixed(1)).toLocaleString(getPreferredLang()) + '%)';
				}
				row.els.push(val);
				row.els.push(valperc);
			}
			else {
				row.els.push( '' );
				row.els.push( '' );
			}
		}
		// todas las especies
		row.els.push( Number(prprops[ifn].nallplots).toLocaleString(getPreferredLang()) );
		// incluyo fila
		prtemp.rows.push(row);
	}
	
	// ¿no hay datos?
	if (prtemp.rows.length == 0)
		prtemp.norows = true;
	
	// obtengo el popup y lo devuelvo
	return Mustache.render(provPopupTemplate, prtemp);
}
function colorProvincia(prprops, esBorde) {
	// 2021-05-24 cambio en la manera de obtener el color, ahora me baso en infospecies para incluir a Portugal
	const ifn = Sesion.estado.ifn? Sesion.estado.ifn : config.ifnVersions[config.ifnVersions.length -1];
	let infosar = null;
	const infoSpecies = prprops[ifn]? prprops[ifn].infoSpecies : prprops.infoSpecies;
	if (infoSpecies)
		infosar = Array.isArray(infoSpecies)? infoSpecies : [infoSpecies];
	if (esBorde) {
		let color = config.colores[config.colplotind][4]; // color por defecto
		// si hay taxones seleccionados el color puede cambiar
		if (infosar && Sesion.taxones.length > 0) {
			// preparo colores a mezclar
			let cols = [];
			for (let ind = 0; ind < Sesion.taxones.length; ind++) {
				let coincidencia = false;				
				// CASO PORTUGUÉS: mapeo del IFN3 a otros inventarios
				if (!prprops[ifn] && ifn !== "ifn3") {
					// obtengo array con los mapeos
					const txpt = correspondenciaTaxonMulti( [Sesion.taxones[ind]], "ifn3");
					// miro suma si la suma es >0 para coincidencia
					for (const txptel of txpt) {
						if (sumPropInfoTaxon(infosar, "numberTrees", txptel) > 0)
							coincidencia = true;
					}
				}
				else {
					if (sumPropInfoTaxon(infosar, "numberTrees", Sesion.taxones[ind]) > 0) {
						const caux = config.colores[Sesion.taxonesColores[ind]][4];
						cols.push(caux);
					}
				}
				// incluyo color si hay coincidencia
				if (coincidencia) {
					const caux = config.colores[Sesion.taxonesColores[ind]][4];
					cols.push(caux);
				}
			}
			// si hay algún color...
			if (cols.length > 0)
				color = getColorMix(cols);
		}
		return color;
	}
	else { // interior
		let color = config.colores[config.colplotind][0]; // color por defecto
		// si hay taxones seleccionados el color puede cambiar
		if (infosar && Sesion.taxones.length > 0) {
			// preparo colores a mezclar
			let cols = [];
			for (let ind = 0; ind < Sesion.taxones.length; ind++) {
				// obtengo suma de la especies
				let sumesp = sumPropInfoTaxon(infosar, "numberTrees", Sesion.taxones[ind]);
				// CASO PORTUGUÉS: mapeo del IFN3 a otros inventarios
				if (!prprops[ifn] && ifn !== "ifn3") {
					// obtengo array con los mapeos
					const txpt = correspondenciaTaxonMulti( [Sesion.taxones[ind]], "ifn3");
					// calculo suma
					sumesp = 0;
					for (const txptel of txpt)
						sumesp += sumPropInfoTaxon(infosar, "numberTrees", txptel);				
				}			
				if (sumesp > 0) {
					// obtengo máximo de árboles de la especie en cuestión		
					const lntrees = featprovs.map(function(ft) {
						let num = 0;
						const ftInfoSpecies = ft.properties[ifn]? ft.properties[ifn].infoSpecies : ft.properties.infoSpecies;
						if (ftInfoSpecies) {
							const isar = Array.isArray(ftInfoSpecies)? ftInfoSpecies : [ftInfoSpecies];
							num = sumPropInfoTaxon(isar, "numberTrees", Sesion.taxones[ind]);
						}					
						return num; 
					});
					const ntreesmax = Math.max(...lntrees);
					// obtengo color y guardo
					const caux = getColor(sumesp, ntreesmax, config.colores[Sesion.taxonesColores[ind]]);
					cols.push(caux);
				}
			}
			// si hay algún color...
			if (cols.length > 0)
				color = getColorMix(cols);		
		}
		else { // sin especie seleccionada
			if (infosar && sumPropInfoTaxon(infosar, "numberTrees", config.treeUri) > 0) {
				// obtengo máximo de árboles
				const lntrees = featprovs.map(function(ft) {
					let num = 0;
					const ftInfoSpecies = ft.properties[ifn]? ft.properties[ifn].infoSpecies : ft.properties.infoSpecies;
					if (ftInfoSpecies) {
						const isar = Array.isArray(ftInfoSpecies)? ftInfoSpecies : [ftInfoSpecies];
						num = sumPropInfoTaxon(isar, "numberTrees", config.treeUri);
					}					
					return num; 
				});
				const ntreesmax = Math.max(...lntrees);
				color = getColor(sumPropInfoTaxon(infosar, "numberTrees", config.treeUri), ntreesmax, config.colores[config.colplotind]);
			}
		}		
		return color;
	}
}

function quitarProvincias() {
	// quito capa de provincias
	Layers.provs.clearLayers();
	Layers.provs.bringToBack();
	// pongo flag a falso
	provspintadas = false;
}

export { featprovs, inicializarProvincias, cargarProvincias, pintarProvincias, ajustarColorProvincias, ajustarPopupsProvincias, quitarProvincias };